import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { X } from 'lucide-react';

import css from './PlatformTopBanner.module.css';

const PlatformTopBanner = ({ children, onDismiss, rootClassName, className }) => {
  const [animatingOut, setAnimatingOut] = useState(false);
  const hasDismiss = typeof onDismiss === 'function';

  const handleClose = () => setAnimatingOut(true);
  const handleTransitionEnd = (e) => {
    if (e.target !== e.currentTarget) return;
    if (animatingOut && hasDismiss) onDismiss();
  };

  const classes = classNames(rootClassName || css.root, className, {
    [css.animatingOut]: animatingOut,
  });

  return (
    <div className={classes} onTransitionEnd={handleTransitionEnd}>
      <div className={css.pill}>
        <p className={css.text}>{children}</p>
        {hasDismiss && (
          <button className={css.close} onClick={handleClose} aria-label="Dismiss">
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

PlatformTopBanner.defaultProps = {
  rootClassName: null,
  className: null,
  onDismiss: null,
};

PlatformTopBanner.propTypes = {
  children: PropTypes.node.isRequired,
  onDismiss: PropTypes.func,
  rootClassName: PropTypes.string,
  className: PropTypes.string,
};

export default PlatformTopBanner;
